export const Melting_DE = [
  [
    'Ein Gletscher entsteht',
    "Vor etwa 100'000 Jahren beginnt sich am abfallenden Rand des westantarktischen Festlandsockels Eis zu bilden.",
  ],

  [
    'Das Eis wird dicker',
    'Weil die Temperaturen zurückgehen und mehr Schnee fällt, wird das Eis lange Zeit dicker und drückt zunehmend auf den Boden unter dem Gletscher.',
  ],

  [
    'Die Folgen der Ozeanerwärmung',
    'Doch nun geschieht Folgendes: «Warmes» Wasser aus der Tiefe des Ozeans lässt das Eisschelf kollabieren, dringt zum westantarktischen Festland vor und unterspült den Eisschild.',
  ],

  [
    'Der Gletscher gerät unter Druck',
    'Das Festlandeis schmilzt, verliert die Haftung am Boden und gleitet ins Meer.',
  ],
  [
    'Der Kollaps beginnt',
    'Und während sich das Wasser aufgrund der retrograden Neigung immer tiefer unter den Gletscher frisst und das Eis vom Landesinneren her drückt, gleitet dieser immer weiter ab. Die vordere Gletscherwand kollabiert, und immer mehr Eis stürzt ins Meer – der Gletscher «kalbt».',
  ],
]
export const Melting_FR = [
  [
    'FR_Ein Gletscher entsteht',
    "FR_Vor etwa 100'000 Jahren beginnt sich am abfallenden Rand des westantarktischen Festlandsockels Eis zu bilden.",
  ],

  [
    'FR_Das Eis wird dicker',
    'FR_Weil die Temperaturen zurückgehen und mehr Schnee fällt, wird das Eis lange Zeit dicker und drückt zunehmend auf den Boden unter dem Gletscher.',
  ],

  [
    'FR_Die Folgen der Ozeanerwärmung',
    'FR_Doch nun geschieht Folgendes: «Warmes» Wasser aus der Tiefe des Ozeans lässt das Eisschelf kollabieren, dringt zum westantarktischen Festland vor und unterspült den Eisschild.',
  ],

  [
    'FR_Der Gletscher gerät unter Druck',
    'FR_Das Festlandeis schmilzt, verliert die Haftung am Boden und gleitet ins Meer.',
  ],
  [
    'FR_Der Kollaps beginnt',
    'FR_Und während sich das Wasser aufgrund der retrograden Neigung immer tiefer unter den Gletscher frisst und das Eis vom Landesinneren her drückt, gleitet dieser immer weiter ab. Die vordere Gletscherwand kollabiert, und immer mehr Eis stürzt ins Meer – der Gletscher «kalbt».',
  ],
]
